<template>
  <div class="w-100">
    <a-result
      status="403"
      title="403 - Akses Dilarang"
      sub-title="Maaf, Anda tidak memiliki akses untuk halaman ini."
    >
      <template #extra>
        <a-button type="primary" size="large" @click.prevent="$router.replace({ path: '/dashboard', query: { ...$route.query } })">
          Kembali ke Dashboard
        </a-button>
      </template>
    </a-result>
  </div>
</template>

<script>
export default {
  name: '403Error',
  setup() {},
}
</script>
